<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>


<!-- MAIN SCREEN -->
<div class="card" *ngIf="translations && globalUserPreferences?.storeId != null">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_go_Back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <!-- LANGUAGE FORM -->
        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- COORDINATION FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12" [formGroup]="globalUserDataForm">

                    <!-- INPUT LANGUAGE -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('selectedLanguage').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_language}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="languages" formControlName="selectedLanguage" optionLabel="value"
                                [showClear]="true" placeholder="Seleccione un lenguaje"
                                (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                    </div>

                    <!-- INPUT PERIOD -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('selectedPeriod').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>{{translations.lbl_period}}</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="periods" formControlName="selectedPeriod"
                                placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="descrip"
                                [showClear]="true" [filter]="true" (onChange)="onChangeUserPreferences()"></p-dropdown>
                        </div>
                    </div>

                    <!-- INPUT COUNTRY -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('selectedCountry').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Coordinación/ País / Ciudad</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="countries" formControlName="selectedCountry" optionLabel="descrip"
                                [showClear]="true"
                                placeholder="Seleccione una Coordinación/ País / Ciudad"></p-dropdown>
                        </div>
                    </div>

                    <!-- DROPDOWN COORDINATION -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('baseSelectedCoordination').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>País</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="baseCordinationCatalogList"
                                formControlName="baseSelectedCoordination" optionLabel="store.descri" [showClear]="true"
                                placeholder="Seleccione un lenguaje"
                                (onChange)="baseSelectionCoordinationCatalog(this.baseSelectedCoordination)"></p-dropdown>
                        </div>
                    </div>


                    <!-- INPUT CURRENCIES -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('selectedFromCurrency').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>De Moneda</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="fromCurrencies" formControlName="selectedFromCurrency"
                                placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="value" [showClear]="true"
                                [filter]="true"></p-dropdown>
                        </div>
                    </div>


                    <!-- INPUT CURRENCIES -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('selectedToCurrency').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>A Moneda</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown id="listStore" [options]="toCurrencies" formControlName="selectedToCurrency"
                                placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="value" [showClear]="true"
                                [filter]="true"></p-dropdown>
                        </div>
                    </div>

                    <!-- INPUT BANK NAME -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Nombre De Cuenta</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedBankName">
                        </div>
                    </div>


                    <!-- INPUT BANK ACCOUNT -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Nombre De Cuenta</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <input type="text" pInputText formControlName="selectedBankAccount">
                        </div>
                    </div>

                    <!-- DROPDOWN COORDINATION -->
                    <!-- <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('fromSelectedCoordination').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Moneda Origen</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="fromCordinationCatalogList"
                                formControlName="fromSelectedCoordination" optionLabel="store.descri" [showClear]="true"
                                placeholder="Seleccione un lenguaje"
                                (onChange)="fromSelectionCoordinationCatalog(this.fromSelectedCoordination)"></p-dropdown>
                        </div>
                    </div> -->


                    <!-- DROPDOWN COORDINATION -->
                    <!-- <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1"
                        *ngIf="globalUserDataForm.get('toSelectedCoordination').value != null">
                        <div class="subTitle p-col-12 p-md-4">
                            <span>Moneda Destino</span>
                        </div>
                        <div class="p-col-12 p-md-8">
                            <p-dropdown [options]="toCordinationCatalogList" formControlName="toSelectedCoordination"
                                optionLabel="store.descri" [showClear]="true" placeholder="Seleccione un lenguaje"
                                (onChange)="toSelectionCoordinationCatalog(this.toSelectedCoordination)"></p-dropdown>
                        </div>
                    </div> -->

                    <!-- BUTTON PACKAGE INPUT -->
                    <div class="p-formgrid p-grid p-ai-center p-jc-between p-pt-1 p-py-1  button-container">
                        <button type="button" pButton pRipple icon="pi pi-save" label="Guardar"
                            (click)="createStoreCurrency()" class="p-button-success p-m-2 button-save"
                            pTooltip="Guardar" tooltipPosition="bottom"></button>
                    </div>
                </div>
            </p-panel>
        </div>
    </div>

    <br />

    <!-- TAB VIEW -->
    <p-tabView>
        <!-- TAB PANEL -->
        <p-tabPanel [header]="translations.lbl_currency">


            <p-table #dt1 [value]="currenciesStore" [paginator]="true" [rows]="10" [showCurrentPageReport]="false"
                [globalFilterFields]="colsGlCurrencies" responsive="true" editMode="row" dataKey="id.storeId">

                <!-- CAPTION -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>
                            <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                                class="p-button-success p-m-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>

                            <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                                class="p-button-warning p-m-2" pTooltip="PDF" tooltipPosition="bottom"></button>

                            <button pButton pRipple label="" icon="pi pi-sync" class="p-button-danger p-m-2 z-5"
                                (click)="reloadGetStoreCurrencies()"></button>
                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="id.storeId">{{translations.lbl_coordination}}<p-sortIcon
                                field="id.storeId"></p-sortIcon></th>
                        <th pSortableColumn="id.year">{{translations.lbl_year}}<p-sortIcon field="id.year"></p-sortIcon>
                        </th>
                        <th pSortableColumn="id.countryId">{{translations.lbl_country}}<p-sortIcon
                                field="id.countryId"></p-sortIcon></th>
                        <th pSortableColumn="id.currency">{{translations.lbl_currency}}<p-sortIcon
                                field="id.currency"></p-sortIcon></th>
                        <th pSortableColumn="id.currencyDest">{{translations.lbl_currency}}<p-sortIcon
                                field="id.currencyDest"></p-sortIcon></th>
                        <th pSortableColumn="status">{{translations.lbl_status}}<p-sortIcon field="status"></p-sortIcon>
                        </th>
                        <th>{{translations.lbl_edit}}</th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-valor let-editing="editing" let-ri="rowIndex">
                    <tr [pSelectableRow]="valor" [pEditableRow]="valor">
                        <td>{{ valor?.id?.storeId ? valor?.id?.storeId : " " }}</td>
                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-dropdown id="toListYear" [options]="years" [(ngModel)]="valor.id.year"
                                        placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="year"
                                        optionValue="year" [showClear]="true" [filter]="true"></p-dropdown>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{valor?.id?.year}}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td>{{ valor?.id?.countryId ? valor?.id?.countryId : " " }}</td>

                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-dropdown id="toListStore" [options]="selectedCurrencies"
                                        [(ngModel)]="valor.id.currency"
                                        placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="value"
                                        optionValue="valueId" [showClear]="true" [filter]="true"></p-dropdown>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{valor?.id?.currency}}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td>
                            <p-cellEditor>
                                <ng-template pTemplate="input">
                                    <p-dropdown id="fromListStore" [options]="selectedCurrencies"
                                        [(ngModel)]="valor?.id.currencyDest"
                                        placeholder="{{lbl_select}} {{lbl_coordination}}" optionLabel="value"
                                        optionValue="valueId" [showClear]="true" [filter]="true"></p-dropdown>
                                </ng-template>
                                <ng-template pTemplate="output">
                                    {{valor?.id?.currencyDest}}
                                </ng-template>
                            </p-cellEditor>
                        </td>

                        <td>{{ valor?.status ? valor?.status : " " }}</td>

                        <!-- BUTTONS -->
                        <td>
                            <button *ngIf="!editing" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                pTooltip="{{translations.lbl_edit}}" (click)="onRowEditInit(valor)"
                                class="p-button-warning p-m-2 p-button-rounded"
                                [disabled]="editingRow.storeCurrency != null">
                            </button>

                            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                pTooltip="{{translations.lbl_save}}" (click)="onRowEditSave(valor)"
                                class="p-button-rounded p-button-success p-mr-2"></button>

                            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                (click)="onRowEditCancel(valor, ri)" pTooltip="{{translations.lbl_back}}"
                                class="p-button-rounded p-button-danger p-mr-2"></button>

                            <button class="p-button-danger p-m-2 p-button-rounded" pButton pRipple type="button"
                                icon="pi pi-trash" pTooltip="{{translations.lbl_delete}}" (click)="onRowDelete(valor)">
                            </button>

                        </td>

                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 9">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="p-d-flex p-ai-center p-jc-between">
                        {{translations.lbl_there_are}} {{currenciesStore != null ? currenciesStore.length : 0 }}
                        {{translations.lbl_records}}.
                    </div>
                </ng-template>
            </p-table>


        </p-tabPanel>
    </p-tabView>
</div>


<!-- OVERLAY SCREEN NO STORE ID -->
<div *ngIf="globalUserPreferences?.storeId == null" class=" overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">Verifica sesión e intenta mas tarde ... </span>
</div>